export default class SessionStorageHandler {
  storage: Map<string, string>;

  sessionStorageSupported: boolean;

  constructor() {
    this.storage = new Map<string, string>();
    this.sessionStorageSupported = !!window.sessionStorage;
  }

  setItem(key: string, value: string): void {
    if (this.sessionStorageSupported) {
      sessionStorage.setItem(key, value);
    } else {
      this.storage.set(key, value);
    }
  }

  getItem(key: string): string | null {
    if (this.sessionStorageSupported) {
      return sessionStorage.getItem(key);
    }

    return this.storage.get(key) || null;
  }

  remove(key: string): void {
    if (this.sessionStorageSupported) {
      sessionStorage.removeItem(key);
    } else {
      this.storage.delete(key);
    }
  }
}
